import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { DeviceManagementService } from '../device-management.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { EnterpriseService } from 'src/app/enterprise/enterprise.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { UsersService } from 'src/app/users/users.service';
import { SitesService } from 'src/app/sites/sites.service';
import * as _ from 'lodash';
import { DeviceService } from 'src/app/home/site-dashboard/device/device.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ColumnsConfig, TableConfig, TableData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceTypeService } from 'src/app/home/site-dashboard/device/device-type.service';

@Component({
	selector: 'app-manage-device-page',
	templateUrl: './manage-device-page.component.html',
})
export class ManageDevicePageComponent implements OnInit {
	@ViewChild("updateSetupDone") updateSetupDone;
	@Input() devicesIds: any = '';
	@Input() render: string = "full";
	@Input() fromAdminPanel: boolean = false;
	@Output() deviceOwnerSaved = new EventEmitter<void>();

	// table data
	tableData: TableData[] = [];

	tableConfig: TableConfig = {
		hasExport: false,
		hasPagination: false,
		draggable: true,
		hasSelectionColumn: true,
		selectAll: true,
	};

	columnConfig: ColumnsConfig[] = [
		{ key: 'id', name: 'id', type: 'id'},
		{ key: 'power_view_sn', name: this.translateService.instant('devices.power_view_sn'), type: "string"},
		{ key: 'current_customer', name: this.translateService.instant('g.current_customer'), type: 'string' },
		{ key: 'current_site', name: this.translateService.instant('g.current_site'), type: "string" },
	];

	processSteps = {
		selectDevicesOwner: 1,
		confirmation: 2
	}
	stepsCount = 1;
	selectedDevices: any = [];
	confirmedDevicesSerials = []
	deviceInfo: any = {};
	customers: any = [];
	sites: any = [];
	enterpriseList: any = [];
	customer: any = {};
	site: any = {};
	serialNumbers = [];
	originalOwners: {site_id, customer_id};
	sitesById: any = {};
	tmpDevicesIds: string = '';
	customerEnterprises: any = [];
	newCustomer	= {id: 0, customer_name: this.translateService.instant('site.new_customer'), sites: [{'id': 0, 'name': this.translateService.instant('site.new_site')}], isRequest: false};
	newSite		= {id: 0, name: this.translateService.instant('site.new_site'), isRequest: false};
	siteEnterprises: any = [];
	currentUser: any = {};
	originalDeviceSiteId: number;
	powerStudySiteObj: any = {};

	constructor(
		private deviceManagementService: DeviceManagementService,
		private route: ActivatedRoute,
		private router: Router,
		private notificationMessage: NotificationMessageService,
		private navigation: NavigationService,
		private sideMenuService: SideMenuService,
		private enterpriseService: EnterpriseService,
		private chRef: ChangeDetectorRef,
		private translateService: TranslateService,
		private deviceService: DeviceService,
		public usersService: UsersService,
		public sitesService: SitesService,
		private el: ElementRef,
		private renderer: Renderer2,
		private commonService: CommonService,
		public deviceTypeService: DeviceTypeService,
	){}

	ngOnInit() {
		// The route has no access guard, so leave before anything loads when the page is opened by URL
		if(!this.usersService.hasAccessFunction('manage_device'))
			return this.router.navigate(['/unauthorized']);

		this.currentUser = this.usersService.getCurrentUser();
		if(this.render == "full") {
			this.sideMenuService.hide();
		}
		this.route.params.subscribe(param => {
			this.devicesIds = param.deviceId || '';
			this.devicesIds = this.devicesIds.split(',');
			this.deviceManagementService.getDeviceOwners(this.devicesIds, { allowEmpty: this.fromAdminPanel }).subscribe(
				data => this.init(data)
			);
		});
		this.getEnterpriseList();
		this.site.installation_date = new Date(new Date().setHours(0, 0, 0, 0));
	}

	init(response) {
		this.tmpDevicesIds = this.devicesIds.join(',');
		this.serialNumbers = response.devices.map(device => device.serial_number);
		this.deviceInfo = response.devices[0] || {customer_id: 0, site_id: 0};
		this.powerStudySiteObj = response.power_studies_site;
		if(!this.fromAdminPanel) {
			this.originalDeviceSiteId = this.deviceInfo.site_id;
		}

		this.customers  = response.customersAndSites.sort((item1, item2) => item1.customer_name.toLowerCase() > item2.customer_name.toLowerCase() ? 1 : -1);
		// without the access to create it, "- New Customer -" / "- New Site -" are still offered on the device page, as a request
		this.newCustomer.isRequest = !this.hasAccessOnAddNewCustomer();
		this.newSite.isRequest = !this.usersService.hasAccessFunction('create_site');
		const canRequestNewOwner = !this.fromAdminPanel;

		this.customers = (!this.newCustomer.isRequest || canRequestNewOwner ? [this.newCustomer] : []).concat(this.customers);
		let deviceSiteCustomerId = 0;

		for(let customer of this.customers){
			if (!this.newSite.isRequest || canRequestNewOwner)
				customer.sites.unshift(this.newSite);
			for(let site of customer.sites){
				if(site.id == this.deviceInfo.site_id || customer.study_site_id == this.deviceInfo.site_id){
					deviceSiteCustomerId = customer.id;

					this.sites = customer.sites.filter((site) => site.is_special !== true).sort((item1, item2) => item1.name.toLowerCase() > item2.name.toLowerCase() ? 1 : -1);
					this.deviceInfo.customer_id = customer.id;
					this.deviceInfo.oldCustomerId = customer.id;

					this.originalOwners = {
						site_id: this.deviceInfo.site_id,
						customer_id: this.deviceInfo.customer_id
					};
				}
				// exclude newSite site
				if(site.id)
					this.sitesById[site.id] = site;
			}
		}

		this.getCustomerSites(deviceSiteCustomerId, true);
		if (!this.fromAdminPanel)
			this.commonService.setPageTabTitle(
				`${this.customers.find(customer => customer.id == this.deviceInfo.customer_id).customer_name} - ${this.sites.find(site => site.id == this.deviceInfo.site_id).name} - ${this.deviceInfo.serial_number} - ${this.translateService.instant('devices.manage_device')}`
			);
	}

	handlePowerStudySites(customer) {
		const customerStudySite = customer.sites.find(site => site.name === this.commonService.powerStudiesDevicesSiteName) || this.powerStudySiteObj;

		this.sites = [customerStudySite];
		this.site = customerStudySite;
		this.deviceInfo.oldSiteId = this.deviceInfo.site_id;
		this.deviceInfo.site_id = this.site.id;
	}

	hasAccessOnAddNewCustomer() {
		return this.usersService.hasAccessFunction('customer_management') && this.usersService.hasAccessFunction('create_site');
	}

	hasAccessToNewSite() {
		return (this.fromAdminPanel || this.deviceInfo.id) && !this.deviceInfo.site_id && !this.deviceTypeService.isStudyDevice(this.deviceInfo) && this.usersService.hasAccessFunction('create_site');
	}

	getCustomerSites(customerId, firstTime = false) {
		this.sites = [];
		this.site.customer_enterprises = [];
		this.customerEnterprises = [];
		this.deviceInfo.site_id =  this.deviceInfo.site_id;
		const hasManagementAccess = this.usersService.hasAccessFunction('manage_device');
		// special sites are never shown to non-SCT users
		const hasManagementSpecialSiteAccess = this.usersService.hasAccessFunction('special_site_device_management')
			&& !!this.currentUser?.isSCT;

		if(!customerId && this.usersService.hasAccessFunction('create_site')){
			this.sites = [this.newSite];
			this.deviceInfo.site_id = 0;
			return;
		}

		for(let customer of this.customers){
			if(customer.id == customerId){
				if (this.deviceTypeService.isStudyDevice(this.deviceInfo))
					return this.handlePowerStudySites(customer);

				if (!this.usersService.hasAccessFunction('super_admin', 'write'))
					customer.sites = customer.sites.filter((site: any) =>
						(hasManagementAccess && (!site.is_special || (site.is_special && hasManagementSpecialSiteAccess))));

				const realSites = customer.sites.filter(site => site.id && site.name !== this.commonService.powerStudiesDevicesSiteName)
					.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
				// "- New Site -" stays first whatever the site names sort to (e.g. "_Yard" sorts before "-")
				this.sites = (customer.sites.includes(this.newSite) ? [this.newSite] : []).concat(realSites);

				if (!firstTime) {
					if (realSites.length)
						this.deviceInfo.site_id = realSites[0].id;
					else if (this.sites.length)
						this.deviceInfo.site_id = this.newSite.isRequest ? null : this.newSite.id;
					else // nothing to pick, don't keep the previous customer's site
						this.deviceInfo.site_id = null;
				}

				this.handleCustomerEnterprises(customer);
				break;
			}
		}
	}

	onCustomerChange(customerId) {
		if (!customerId && this.newCustomer.isRequest)
			return this.goToManageDeviceRequest({newOwner: 'customer'});

		this.getCustomerSites(customerId);
	}

	onSiteChange(siteId) {
		if (!siteId && this.newSite.isRequest)
			this.goToManageDeviceRequest({newOwner: 'site', customerId: this.deviceInfo.customer_id});
	}

	goToManageDeviceRequest(queryParams: {newOwner: 'customer' | 'site', customerId?: number}) {
		this.router.navigate(['/device', 'management-request', this.devicesIds.join(',')], {queryParams});
	}

	isSelectedSiteIsSpecial(siteId) {
		if(this.sitesById[siteId])
			return this.sitesById[siteId].is_special;

		if(this.site)
			return this.site.is_special;

		return false;
	}

	onBeforeSaveDeviceOwners() {
		// Site is left empty when "- New Site -" can only be requested, and the form validation doesn't check it
		if (this.deviceInfo.customer_id && this.deviceInfo.site_id == null)
			return this.showSiteRequired();

		if(this.fromAdminPanel) {
			return this.getDevicesInfoBySerialNumber();
		}

		if (this.shouldShowSetupPopup()) {
			return this.updateSetupDone.show();
		}

		return this.saveDeviceOwners(false);
	}

	showSiteRequired() {
		const siteSelect = this.el.nativeElement.querySelector('[name=site_id]');
		if (siteSelect)
			this.renderer.addClass(siteSelect, 'invalid-input');

		this.notificationMessage.setMessage('translate|g.field_required', {clearOnXTimeNavigate: 1});
	}

	shouldShowSetupPopup() {
		if(this.selectedDevices.length)
			return this.selectedDevices.some(device => !device.setup_done);

		return !this.deviceInfo.setup_done && !this.isSelectedSiteIsSpecial(this.deviceInfo.site_id) &&
			(this.originalOwners.customer_id != this.deviceInfo.customer_id || this.originalOwners.site_id != this.deviceInfo.site_id);
	}

	showSetupPopup() {
		if(this.shouldShowSetupPopup())
			return this.updateSetupDone.show();

		this.updateSetupDone.hide();
		this.saveDeviceOwners(false);
	}

	getDevicesInfoBySerialNumber() {
		this.devicesIds = this.tmpDevicesIds.replace(/ /g,'').replace(/\n/g,'').split(',');
		this.deviceService.getDevicesInfoBySerialNumber(this.devicesIds).subscribe((data: any) => {
			if (!data.length)
				return this.notificationMessage.setMessage('translate|g.invalid_serial_numbers',{clearOnXTimeNavigate: 1, type: 'warning'});

			this.stepsCount = this.processSteps.confirmation;
			this.selectedDevices = data;
			const tableData = [];

			for(const device of this.selectedDevices ) {
				tableData.push({
					id: {value: device.serial_number, selected: true},
					power_view_sn: {value: device.serial_number},
					current_customer: {value: device.customer_name},
					current_site: {value: device.site_name},
				})
			}

			this.tableData = tableData;

			this.confirmedDevicesSerials = this.selectedDevices.filter(device => device.site_id != this.deviceInfo.site_id).map(device => device.serial_number);
		})
	}

	inTheSameSite(device: any) {
		return device.site_id == this.deviceInfo.site_id;
	}

	getSelectedCustomerName() {
		if (this.deviceInfo.customer_id) {
			const customer = this.customers.filter(customer => customer.id == this.deviceInfo.customer_id).map(customer => customer.customer_name);
			return customer[0];
		}

		return this.customer.customer_name;
	}

	saveDeviceOwners(changeSetupDone = false) {
		let tempSite = Object.assign({}, this.site);
		let insDate = new Date(tempSite.installation_date);
		let manageReason = this.deviceInfo.manage_reason;

		if(this.fromAdminPanel) {
			this.devicesIds = this.confirmedDevicesSerials;
			manageReason = this.translateService.instant('device_management.bulk_device_management_reason');
		}

		if(this.devicesIds.length > 1)
			delete this.deviceInfo.oldCustomerId;

		const customerEnterprises = this.customer?.customer_enterprises || [];
		const siteEnterprises = tempSite?.customer_enterprises || [];

		if (customerEnterprises.length || siteEnterprises.length)
			tempSite.enterprise_ids = _.uniq([...(tempSite.enterprise_ids || []), ...(customerEnterprises.length ? customerEnterprises : siteEnterprises)]);

		// non-SCT users can't pick an enterprise, anything they create belongs to their own enterprise
		let customer = this.customer;
		if (!this.currentUser?.isSCT) {
			const userEnterpriseIds = [Number(this.currentUser.enterprise_id)];
			customer = {...this.customer, customer_enterprises: userEnterpriseIds};
			tempSite.enterprise_ids = userEnterpriseIds;
		}

		tempSite.installation_date = Math.floor((-insDate.getTimezoneOffset() * 60000 + insDate.getTime()) / 1000);
		// PS devices always belong to the customer's "Power Studies Devices" site, the backend resolves it
		if (this.deviceTypeService.isStudyDevice(this.deviceInfo))
			tempSite = {};

		this.deviceManagementService.saveDeviceOwners(this.deviceInfo, customer, tempSite, this.devicesIds, manageReason, changeSetupDone, this.fromAdminPanel).subscribe((res: any)=> {
			this.confirmedDevicesSerials = [];

			switch (res.api_status) {
				case 2:
					const form = this.el.nativeElement;
					const ele = form.querySelectorAll('[name=name]');
					if(ele && ele[0])
						this.renderer.addClass(ele[0], 'invalid-input');

					return this.notificationMessage.setMessage('translate|site.reserved_site_name', { clearOnXTimeNavigate: 1 });
				case 3:
					return this.notificationMessage.setMessage('translate|site.site_not_found', { clearOnXTimeNavigate: 1, type: 'danger' });
				case 4:
					return this.notificationMessage.setMessage('translate|customer.customer_name_already_exist', { clearOnXTimeNavigate: 1, type: 'danger' });
				case 5:
					return this.notificationMessage.setMessage('translate|site.site_name_already_exist', { clearOnXTimeNavigate: 1, type: 'danger' });
				default:
					break;
			}

			if(this.render == 'full') {
				this.notificationMessage.setMessage('globalSuccessMsg');
				if(!this.fromAdminPanel)
					return this.goBack(this.devicesIds, res.customer_id, res.site_id);

				window.location.reload();
			} else {
				this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
			}
			this.deviceOwnerSaved.emit();
		});
	};

	updateSiteCoords(coords) {
		this.site.latitude = coords.lat;
		this.site.longitude = coords.lng;
		this.site.address = coords.address;
		this.site.country_id = coords.country;
		this.site.state_id = coords.state;
		this.site.city = coords.city;
		this.chRef.detectChanges();
	}

	getEnterpriseList() {
		// non-SCT users don't pick an enterprise
		if (!this.currentUser?.isSCT)
			return;

		this.enterpriseService.getEnterprises({site_edit: true, source: 'manage_device'}).subscribe(enterpriseData=> {
			this.enterpriseList = enterpriseData;
		});
	}

	handleCustomerEnterprises(customer) {
		this.site.customer_enterprises = customer.customer_enterprises || [];
		this.customerEnterprises = Array.isArray(customer.customer_enterprises)
			? this.enterpriseList.filter((item) => customer.customer_enterprises.includes(item.id))
			: [];

		this.siteEnterprises = this.enterpriseList.filter((item) => !this.site.customer_enterprises.includes(item.id));
	}

	goBack(devicesId?, customerId?, siteId?){
		if (this.stepsCount == this.processSteps.confirmation)
			return this.stepsCount = this.processSteps.selectDevicesOwner;

		if(!this.usersService.hasAccessFunction('manage_device')) {
			return this.router.navigate(['/sites-map']);
		}
		if(!devicesId || devicesId.length > 1)
			return this.navigation.goBack(['/device/search']);

		this.router.navigate(['/', customerId, siteId, devicesId[0]]);
	}

	updateSelectedDevice(devices) {
		this.confirmedDevicesSerials = devices.map(device => device.id.value);
	}
}
